import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Mid2ColSt from './Mid2ColSt';
import Mid2ColDr from './Mid2ColDr';



class Mid2Col extends React.Component {

    render() {
        if (this.props.loterii) {
            return (
                <div>
                    <Mid2ColSt />
                    <Mid2ColDr />
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        loterii: state.loterii
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(Mid2Col);